//@flow

import type { Node } from "react";
import React from "react";

import { Spinner } from "@/components";
import type { PromiseStateType } from "@/components/PromiseWatcher/PromiseWatcher";
import ArrowIcon from "@/images/ArrowForward.inline.svg";
import CheckIcon from "@/images/CheckIcon.inline.svg";
import ErrorIcon from "@/images/ErrorIcon.inline.svg";
import { classNameOf } from "@/utils";

type Props = {
    state: PromiseStateType,
    variant: "dark" | "light",
    submit?: boolean,
    children?: Node,
};

function getIcon(state: PromiseStateType) {
    switch (state) {
        case "idle":
            return <ArrowIcon />;
        case "loading":
            return <Spinner />;
        case "error":
            return <ErrorIcon />;
        case "success":
            return <CheckIcon />;
    }
}

const ActionButton = ({submit, state, variant, children}: Props): React$Element<"button"> => {
    const type = submit ? "submit" : "button";
    const className = classNameOf(
        {
            loading: state === "loading",
            idle: state === "idle",
            error: state === "error",
            success: state === "success",
        },
        "action-button",
        variant,
    );
    return (
        <button type={type} className={className}>
            {children}

            <div className="icon transition">{getIcon(state)}</div>
        </button>
    );
};

export default ActionButton;
